<template>
  <img src="http://yunlei-rabbit-hn2.oss-cn-heyuan.aliyuncs.com/2025/4/8/1909585608538914818.png" />
  <form action="/">
    <div class="box" style="margin-top: -30px">
      <van-cell-group inset style="height: 42px" class="container">
        <van-field v-model="value" label="姓名" placeholder="请输入您的真实姓名 " />
      </van-cell-group>
      <van-cell-group inset style="height: 42px" class="container">
        <van-field v-model="value1" label="手机" placeholder="请输入您的联系方式 " type="digit" />
      </van-cell-group>
      <van-cell-group inset style="height: 42px" class="container">
        <van-field is-link v-model="displayValue" label="性别" placeholder="请选择性别 " @click="showPopup"></van-field>
        <van-popup v-model:show="show" position="bottom" :style="{ height: '50%' }" round>
          <van-picker title="选择性别" :columns="columns" @confirm="onConfirm" @cancel="onCancel"
            :columns-field-names="{ text: 'text', value: 'value' }" />
        </van-popup>
      </van-cell-group>
      <van-cell-group inset style="height: 42px" class="container">
        <van-field is-link v-model="text3" label="校区/站点" placeholder="请选择校区/站点" @click="station"></van-field>
        <van-popup v-model:show="show1" position="bottom" :style="{ height: '50%' }" round>
          <van-picker title="选择校区/站点" :columns="schoolList" @confirm="onConfirm1" @cancel="onCancel1"
            :columns-field-names="customFieldName" />
        </van-popup>
      </van-cell-group>
    </div>
    <div class="button" @click="join">
      <van-button type="primary" color="white" block round>
        <text style="color: skyblue; font-weight: bold; font-size: 20px">提交申请</text>
      </van-button>
    </div>
  </form>
</template>

<script>
import { ref } from "vue";
import { Toast, Dialog } from "vant";
import { req } from "@/axios/http";
import { getSchoolList } from "@/api/total-point";

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  setup() {
    const value = ref("");
    const value1 = ref("");
    const value2 = ref("");
    const value3 = ref("");
    const text3 = ref("");
    const show = ref(false);
    const show1 = ref(false);
    const showPopup = () => {
      show.value = true;
    };
    const station = () => {
      show1.value = true;
    };
    const displayValue =ref(""); 
    const columns = [
      { text: '男', value: 0 },
      { text: '女', value: 1 }
    ];
    // const columns1 = ['贵州水利水电职业技术学院', '贵州师范大学花溪校区', '贵州师范大学西校区'];
    const onCancel = () => (show.value = false);
    const onCancel1 = () => (show1.value = false);
    const customFieldName = {
      text: "name",
    };

    return {
      value,
      value1,
      value2,
      value3,
      text3,
      show,
      show1,
      showPopup,
      station,
      columns,
      // columns1,
      onCancel,
      onCancel1,
      schoolList: [],
      customFieldName,
      displayValue
    };
  },
  methods: {
    join() {
      var num = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
      if (this.value == "") Toast("输入的真实姓名不能为空!!");
      else if (this.value1 == "") Toast("输入的联系方式不能为空!!");
      else if (this.value1.length != 11) Toast("输入正确的电话号码!!");
      else if (!num.test(this.value1)) Toast("输入正确的电话号码!!");
      else if (this.value2 === null || this.value2 === undefined || this.value2 === '') Toast("请选择性别!!");
      else if (this.value3 == "") Toast("请选择校区/站点");
      else
        req
          .post({
            url: "/app/rider/add",
            data: {
              mobile: this.value1,
              realName: this.value,
              sex: this.value2,
              schoolId: this.value3,
            },
          })

          .then((res) => {
            console.log(res);
            if (res.code === 200) {
              // 成功时读取 msg
              const successMsg = res.msg || "24小时内会有客服和您联系，请保持通讯通畅";
              Dialog.alert({
                title: "申请成功",
                message: successMsg,
                theme: "round-button",
                confirmButtonColor: "#00c4ff",
              }).then(() => {
                this.value = "";
                this.value1 = "";
                this.value2 = "";
                this.value3 = "";
                this.text3 = "";
                this.displayValue = "";
              });
            } else {
              // 失败时读取 msg
              const errorMsg = res.msg || "提交申请失败，请稍后重试";
              Toast.fail(errorMsg);
            }
          })
          .catch((error) => {
            // 网络错误或其他错误
            console.error("请求出错:", error);
            Toast.fail("网络错误，请稍后重试");
          })
    },
    onConfirm(selected) {
      this.value2 = selected.value;
      this.displayValue = selected.text;
      this.show = false;
      // this.value2 = IP;
      // this.show = false;
    },
    onConfirm1(schoolMessage) {
      console.log('schoolMessage',schoolMessage);
      this.value3 = schoolMessage.id;
      this.text3 = schoolMessage.name;
      this.show1 = false;
    },
  },
  created() {
    document.title = "兼职招聘";

    getSchoolList({ current: 1, size: 1000 }).then((res) => {
      console.log(res);
      if (res.code === 200) {
        this.schoolList = res.data.records;
        console.log("res.data.records",res.data.records)
      }
    });
  },
};
</script>

<style scoped>
#app {
  height: 100%;
  background-color: #fca028;
}

img {
  width: 100%;
}

.container {
  margin: 25px 15px;
  font-size: 20px;
}

label {
  font-weight: bold;
  color: black;
  font-size: 35px;
}

.button {
  width: 80%;
  margin: 40px auto;
}
</style>
